import { useRef } from 'react';
import { Mail, MapPin, Phone } from 'lucide-react';
import { legalPages, operatorDetails } from '../data/legalPages';
import { requestCookiePreferences } from '../lib/consent';
import { BrandLogo } from './BrandLogo';

const serviceSlugs = new Set(['/levering-en-verzending/', '/retouren/', '/garantie/', '/productveiligheid/']);
const legalSlugs = new Set(['/algemene-voorwaarden/', '/privacybeleid/', '/cookiebeleid/', '/herroepingsformulier/']);

export function LegalFooter() {
  const cookiePreferencesButtonRef = useRef<HTMLButtonElement>(null);
  const servicePages = legalPages.filter((page) => serviceSlugs.has(page.slug));
  const legalLinks = legalPages.filter((page) => legalSlugs.has(page.slug));
  const contactPage = legalPages.find((page) => page.slug === '/contact/');

  return (
    <footer className="legalFooter" aria-label="Service en juridische informatie">
      <div className="legalFooterInner">
        <section>
          <BrandLogo className="footerBrandLogo" compact />
          <p>
            Pickleball specialist voor Nederland en Belgie. Bekijk producten, start de keuzehulp of vraag
            pakketadvies voor club en school aan.
          </p>
          <div className="footerContact">
            <span><MapPin size={17} aria-hidden="true" /> {operatorDetails.address}</span>
            <a href={`mailto:${operatorDetails.email}`}><Mail size={17} aria-hidden="true" /> {operatorDetails.email}</a>
            <a href="tel:+31619200380"><Phone size={17} aria-hidden="true" /> {operatorDetails.phone}</a>
          </div>
        </section>

        <nav aria-label="Servicepagina's">
          <h2>Service</h2>
          {servicePages.map((page) => (
            <a key={page.slug} href={page.slug}>{page.navLabel}</a>
          ))}
          <a href="/retour-aanmelden/">Retour aanmelden</a>
          {contactPage ? <a href={contactPage.slug}>{contactPage.navLabel}</a> : null}
        </nav>

        <nav aria-label="Juridische pagina's">
          <h2>Juridisch</h2>
          {legalLinks.map((page) => (
            <a key={page.slug} href={page.slug}>{page.navLabel}</a>
          ))}
          <button
            ref={cookiePreferencesButtonRef}
            type="button"
            onClick={() => requestCookiePreferences(cookiePreferencesButtonRef.current)}
          >
            Cookievoorkeuren
          </button>
        </nav>

        <section>
          <h2>Bedrijfsgegevens</h2>
          <p>{operatorDetails.legalOwner} / {operatorDetails.operatingGroup}</p>
          <p>KVK {operatorDetails.kvk}</p>
          <p>BTW {operatorDetails.vat}</p>
          <p className="footerFineprint">
            Online bestellen opent zodra prijs, levering, retouren en productinformatie definitief zijn.
          </p>
        </section>
      </div>
    </footer>
  );
}
